import { render } from "./bmi.vue?vue&type=template&id=43fd035b&scoped=true"
import script from "./bmi.vue?vue&type=script&lang=js"
export * from "./bmi.vue?vue&type=script&lang=js"

import "./bmi.vue?vue&type=style&index=0&id=43fd035b&scoped=true&lang=css"

import exportComponent from "/code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43fd035b"]])

export default __exports__